import { SendOutlineIcon } from './SendOutlineIcon';

/**
 * author: Simran
 * id B4F0331A-3E21-40C4-AED4-A28FD929AD21
 * name send-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/send-outline.svg
 * tags
 */
export const PaperAirplaneOutlineIcon = SendOutlineIcon;
export default PaperAirplaneOutlineIcon